import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
} from "@mui/material";
import "./faq.css";
import { CallWithOutAuth } from "../../action/apiActions";
import { All_FAQ } from "../../action/apiPath";
import Loading from "react-fullscreen-loading";



export const FaqPage = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [fetchData, setfetchData] = useState([]);

  React.useEffect(() => {
    getData();
  }, []
  );

  const getData = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithOutAuth("GET", `${All_FAQ}`);
      if (response.res.status == 200) {
        console.log(response.res?.data?.data);
        setfetchData(response?.res?.data?.data);
        // console.log('setfetchData', fetchData);
      } else {
        // showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panelIndex) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelIndex : false);
  };
  return (
    <>
     {isLoading && (
              <Loading
                loading
                background="rgba(236, 240, 241, 0.7)"
                loaderColor="#3498db"
              />
            )}
      <section className="csm_page_wrapper_faq mt-10">
        <div className="faq_container" style={{ marginTop: "100px" }}>
          <h1 className="csm_page_title">Frequently Asked Questions</h1>
          <div className="accordion-container">
            {fetchData?./*filter(faq => faq.is_active)?.*/sort((a, b) => a.order - b.order)?.map((faq, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={handleChange(index)}
                className="mb-3"
              >
                <AccordionSummary
                  // expandIcon={<i className="fas fa-plus"></i>}
                  expandIcon={
                    expanded === index ? (
                      <i className="fas fa-minus"></i>
                    ) : (
                      <i className="fas fa-plus"></i>
                    )
                  }
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >{faq.question}
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">{faq.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqPage;
